import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import LoadingSpinner from '../common/LoadingSpinner';

function DmsManagement() {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({ name: '', logo: '', isActive: 1 });

  useEffect(() => {
    loadProviders();
  }, []);

  const loadProviders = async () => {
    setLoading(true);
    try {
      const data = await api.getMasterData('dms');
      setProviders(data);
    } catch (err) {
      console.error('Failed to load DMS providers:', err);
      alert('Failed to load DMS providers');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.updateMasterData('dms', editing.id, formData);
      } else {
        await api.createMasterData('dms', formData);
      }
      loadProviders();
      setShowAdd(false);
      setEditing(null);
      setFormData({ name: '', logo: '', isActive: 1 });
    } catch (err) {
      console.error('Failed to save DMS provider:', err);
      alert('Failed to save DMS provider');
    }
  };

  const handleEdit = (provider) => {
    setEditing(provider);
    setFormData({
      name: provider.name,
      logo: provider.logo || '',
      isActive: provider.is_active
    });
    setShowAdd(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this DMS provider?')) {
      try {
        await api.deleteMasterData('dms', id);
        loadProviders();
      } catch (err) {
        console.error('Failed to delete DMS provider:', err);
        alert('Failed to delete DMS provider');
      }
    }
  };

  if (loading) return <LoadingSpinner message="Loading DMS providers..." />;

  return (
    <div className="dms-management">
      <div className="management-header">
        <h2>DMS Providers</h2>
        <button className="btn btn-primary" onClick={() => setShowAdd(true)}>
          <i className="fas fa-plus"></i> Add Provider
        </button>
      </div>

      {showAdd && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{editing ? 'Edit DMS Provider' : 'Add DMS Provider'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Provider Name *</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Logo URL</label>
                <input
                  type="url"
                  className="form-control"
                  value={formData.logo}
                  onChange={(e) => setFormData({...formData, logo: e.target.value})}
                  placeholder="https://example.com/logo.png"
                />
              </div>
              <div className="form-group">
                <label>Active</label>
                <select
                  className="form-control"
                  value={formData.isActive}
                  onChange={(e) => setFormData({...formData, isActive: parseInt(e.target.value)})}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => {
                  setShowAdd(false);
                  setEditing(null);
                  setFormData({ name: '', logo: '', isActive: 1 });
                }}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {editing ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>Logo</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {providers.map((provider) => (
              <tr key={provider.id}>
                <td><strong>{provider.name}</strong></td>
                <td>
                  {provider.logo && <img src={provider.logo} alt={provider.name} height={30} />}
                </td>
                <td>
                  <span className={`status-badge ${provider.is_active ? 'active' : 'inactive'}`}>
                    {provider.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="actions">
                  <button className="btn btn-sm btn-secondary" onClick={() => handleEdit(provider)}>
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(provider.id)}>
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DmsManagement;